const datedSubcategories = new Set([
  'Aufenthaltsnachweis',
  'Personalausweis'
])

function isExpired(file, today) {
  return Boolean(
    file.validUntil &&
    datedSubcategories.has(file.subcategory) &&
    String(file.validUntil).slice(0, 10) < today
  )
}

function requiredDocumentStatus({
  subcategory,
  files,
  germanNational,
  confirmed,
  manualValidUntil,
  today
}) {
  if (subcategory === 'Aufenthaltsnachweis' && germanNational === true) return 'nicht erforderlich'
  if (files.some(file => !isExpired(file, today))) return 'Hochgeladen'
  if (!files.length) {
    if (!confirmed) return 'Fehlt'
    if (datedSubcategories.has(subcategory)) {
      if (!manualValidUntil) return 'Fehlt'
      if (manualValidUntil < today) return 'Abgelaufen'
    }
    return 'Manuell bestätigt'
  }
  return 'Abgelaufen'
}

module.exports = {
  isExpired,
  requiredDocumentStatus
}
